import axios from 'axios'

//  -- log client info and errors to server --
// Provides persistent trace of events and errors in client browser
export const LogToServer = (message, error) => {
    // TBD TODO use a debug switch env variable so we aren't logging out info on a user browser
    //console.log(message, error ? error : '')

    axios.post(
        `${process.env.REACT_APP_API}/system/log-message`,
        {
            message,
            error,
        }
    ).catch((loggingError) => {
        console.error('Problem logging, not much to be done about that:', loggingError)
    })
}
